/**
 * The second tile row is open when the user opened it or when the subject of Explore sits in it, and it
 * cannot be closed while the subject is in it, so the subject never vanishes above its own panel.
 */
export function moreMetricsState({
  subjectInSecondRow,
  userOpen,
}: {
  /** The metric being explored is a second-row metric and Explore is open. */
  subjectInSecondRow: boolean;
  userOpen: boolean;
}): { open: boolean; disabled: boolean } {
  return { open: userOpen || subjectInSecondRow, disabled: subjectInSecondRow };
}

export const FEWER_METRICS_DISABLED_HINT = 'Close Explore or pick a headline number first';
